import { render, staticRenderFns } from "./yichuli.vue?vue&type=template&id=2fe96e70"
import script from "./yichuli.vue?vue&type=script&lang=js"
export * from "./yichuli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports